<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          In the past year I served as:
        </p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <ul>
              <li>A City employee,</li>
              <li>An elected City official,</li>
              <li>a member of the City of the Philadelphia Board of Revision of Taxes (BRT), OR</li>
              <li>the Chair of the Commission on Human Relations of the City of Philadelphia</li>
            </ul>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-delete-btn"
          type="button"
          class="button is-ben-franklin-blue"
          :class="isLoadingTrue ? 'is-loading' : ''"
          :disabled="isLoadingTrue || isLoadingFalse"
          @click="isCityEmployee(true)"
        >
          Yes
        </button>
        <button
          id="modal-cancel-btn"
          type="button"
          class="button is-dark"
          :class="isLoadingFalse ? 'is-loading' : ''"
          :disabled="isLoadingTrue || isLoadingFalse"
          @click="isCityEmployee(false)"
        >
          No
        </button>
      </footer>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isLoadingTrue: false,
      isLoadingFalse: false,
    };
  },
  methods: {
    closeModal() {
      if (!this.submitting) {
        this.$emit('close');
      }
    },
    async isCityEmployee (answer) {
      if (answer === true) {
        this.isLoadingTrue = true;
      } else {
        this.isLoadingFalse = true;
      }

      const userProfile = this.$store.state.user.profile;

      await this.$store.dispatch('user/updateUserProfile', { fields: { isCityEmployee: answer }, userId: userProfile.id });

      this.isLoadingTrue = false;
      this.isLoadingFalse = false;
      this.closeModal();

    },
  },
};
</script>
<style lang="scss" scoped>
  .close-button {
    font-size: 25px;
    line-height: 0;
  }
  ul {
    padding: .5rem 1rem;
    li {
      list-style-type: circle;
    }
  }
</style>
